const deviceKey = "fairway-rivalry:device-id";

interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function getDeviceId(
  storage: KeyValueStorage = localStorage,
  createId: () => string = () => crypto.randomUUID(),
): string {
  const current = storage.getItem(deviceKey);
  if (current) return current;
  const created = createId();
  storage.setItem(deviceKey, created);
  return created;
}

export function nextDeviceSequence(
  deviceId: string,
  storage: KeyValueStorage = localStorage,
): number {
  const key = "fairway-rivalry:device-sequence:" + deviceId;
  const next = Number(storage.getItem(key) ?? "0") + 1;
  storage.setItem(key, String(next));
  return next;
}
